import React from 'react';
import { createContext } from 'react';
import ListTableHeader from './ListTableHeader';
import ListTableBody from './ListTableBody';
import Table from "@reactComponents/lds/table/Table";

const TableContext = createContext({
  onListSelected: (e) => {},
  lists: [],
  editable: false,
  showHeader: false,
  showTag: false,
  categories: [],
  enableDeleteBtn: false,
  selectedRows: new Map(),
  entriesAlignment: "start"
});

function ListTable({
  lists,
  editable,
  showHeader,
  showTag,
  onListSelected,
  enableDeleteBtn,
  selectedRows,
  onDeleteButtonClick,
  entriesAlignment
}) {

  return (
    <TableContext.Provider
      value={{
        lists,
        editable,
        showHeader,
        showTag,
        onListSelected,
        enableDeleteBtn,
        selectedRows,
        onDeleteButtonClick,
        entriesAlignment
      }}
    >
      <Table id="list_table" width={"100%"}>
        <ListTableHeader />
        <ListTableBody />
      </Table>
    </TableContext.Provider>
  );
}

export default ListTable;
export { TableContext };
